module.exports = __webpack_public_path__ + "images/industrial-2-3ee21c76f9dae548911fd3273b87a097.jpg";